import moment from 'moment';

// The last day of data shown for the in-progress period, unless the list is
// set to show the entire period ('period'), in which case callers use the
// period's own end date.
const getCurrentPeriodEndDate = ({
  currentPeriodEndDate,
  todayOverride,
}: {
  currentPeriodEndDate: Scorecards.Scorecard['currentPeriodEndDate'];
  todayOverride: string | undefined;
}) =>
  currentPeriodEndDate === 'today'
    ? moment(todayOverride).format('YYYY-MM-DD')
    : moment(todayOverride).subtract({ day: 1 }).format('YYYY-MM-DD');

export default getCurrentPeriodEndDate;
